"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Types_1 = require("../../Types");
var core_1 = require("@athena-portal/core");
var react_router_dom_1 = require("react-router-dom");
var InvoiceCorrectiveMeasuresHeader = /** @class */ (function (_super) {
    __extends(InvoiceCorrectiveMeasuresHeader, _super);
    function InvoiceCorrectiveMeasuresHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.applyInvoiceCorrection = function (event) {
            event.preventDefault();
            _this.setState({ processing: true });
            _this.supportPortalService
                .applyInvoiceCorrection(_this.props.policyNumber)
                .subscribe(function (e) {
                _this.setState({ processing: false });
                if (!(e instanceof Error)) {
                    window.location.reload();
                }
            });
        };
        _this.state = {
            processing: false
        };
        return _this;
    }
    InvoiceCorrectiveMeasuresHeader.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "panel-border px-4", children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.processing }), (0, jsx_runtime_1.jsxs)("div", { className: "row py-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "col-7 font-weight-bold", children: "Policy number" }), (0, jsx_runtime_1.jsx)("div", { className: "col-5", children: this.props.policyNumber }), (0, jsx_runtime_1.jsx)("div", { className: "col-7 py-3 font-weight-bold", children: "Is scenario supported? (currently only supporting most straightforward scenarios: no MTC, no RENEWAL, no MTA additional/refund payments)" }), (0, jsx_runtime_1.jsx)("div", { className: "col-5 py-3", children: this.props.scenarioSupported ? "Supported" : "Not Supported" }), (0, jsx_runtime_1.jsx)("div", { className: "col-12", children: this.props.scenarioSupported
                                ? (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "#", onClick: this.applyInvoiceCorrection, "aria-disabled": !this.props.scenarioSupported, children: "Apply invoice correction" })
                                : (0, jsx_runtime_1.jsx)("p", { className: "text-left", children: "Invoice correction not available" }) })] })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], InvoiceCorrectiveMeasuresHeader.prototype, "supportPortalService", void 0);
    InvoiceCorrectiveMeasuresHeader = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], InvoiceCorrectiveMeasuresHeader);
    return InvoiceCorrectiveMeasuresHeader;
}(React.Component));
exports.default = InvoiceCorrectiveMeasuresHeader;
//# sourceMappingURL=InvoiceCorrectiveMeasuresHeader.js.map